export const greekTranslation =
    {
        "translationLanguageInLocal": "Ελληνικά",
        "metaTags": {
            "homeTitle": "klino.gr",
            "homeDescription": "foo",
            "homeKeywords": "foo",
        },
    }
